import { formatInchesFraction } from "doc/measurementUtils";

type Size2Field = number[];

export function dimension1fractionFunc(denom: number): (num: number) => string {
  return (num: number): string => {
    return formatInchesFraction(num, denom);
  };
}

export function dimension2fractionFunc(denom: number): (dims: Size2Field) => string {
  return (dims: Size2Field): string => {
    if (!(dims.length === 2)) {
      console.assert(false, "dimension2Fraction expects array length of 2");
    }
    const [dim1, dim2] = dims;
    return `${formatInchesFraction(dim1, denom)} x ${formatInchesFraction(dim2, denom)}`;
  };
}

export function removeUnderscore(s: string): string {
  return s.replace(`_`, ` `);
}

export function delimitedList(delimiter = ","): (items: string[]) => string {
  return (items: string[]): string => {
    if (items.length === 0) {
      return "";
    }

    if (items.length === 1) {
      return items[0];
    }

    let stringBuilder = "";
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (i === 0) {
        stringBuilder += item.toLowerCase();
        continue;
      }
      stringBuilder += `${delimiter}${item.toLowerCase()}`;
    }
    return stringBuilder;
  };
}
